export var MemberRoleEnum;
(function (MemberRoleEnum) {
    MemberRoleEnum["ADMIN"] = "org:admin";
    MemberRoleEnum["OWNER"] = "org:owner";
    MemberRoleEnum["AUTHOR"] = "org:author";
    MemberRoleEnum["VIEWER"] = "org:viewer";
    /**
     * @deprecated member is used only in OSS
     */
    MemberRoleEnum["OSS_MEMBER"] = "member";
    /**
     * @deprecated admin is used only in OSS
     */
    MemberRoleEnum["OSS_ADMIN"] = "admin";
})(MemberRoleEnum || (MemberRoleEnum = {}));
//# sourceMappingURL=member.enum.js.map